module.exports = __webpack_public_path__ + "static/media/модернізація-зерно-сушарок-Україна.d929f8a1.jpg";